import { typography } from '@toggle/design-system';
import styled from 'styled-components';

export const Wrapper = styled.main`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: var(--surface-default);
  padding: 24px;
`;

export const Container = styled.div`
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Title = styled.h1`
  ${typography.emu};
  color: var(--text-default);
  margin: 0;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ErrorMessage = styled.p`
  ${typography.koala};
  color: var(--failure--default);
  margin: 0;
  text-align: center;
`;
